import { Button } from '@/components/ui/button'
import { Drawer, DrawerContentRight } from '@/components/ui/drawer'
import { useSettingsPanelState } from '@/hooks/useSettingsPanelState'
import type { WorkspaceDomain } from 'honeygrid-types'
import { LayoutGrid, Plus, Table2 } from 'lucide-react'
import { useState } from 'react'

import { DomainRecordPanel } from './DomainRecordPanel'
import { DomainsCards } from './DomainsCards'
import { DomainsTable } from './DomainsTable'

export function DomainsList() {
	const { state, openCreate, openRecord, closePanel, setView } = useSettingsPanelState('domains')

	// Mock domains data - no backend integration yet
	const [domains] = useState<WorkspaceDomain[]>([])

	const selectedDomain = state.recordId ? domains.find((d) => d.uuid === state.recordId) : undefined

	const handleAdd = () => openCreate()
	const handleSelect = (domain: WorkspaceDomain) => openRecord(domain.uuid)

	const listPanel = (
		<div className="flex flex-col h-full">
			<div className="flex items-center justify-between mb-4">
				<div className="text-lg font-semibold">Domains</div>
				<div className="flex items-center gap-2">
					<div className="flex rounded-md border border-[#3A2E2F]/20">
						<Button
							variant={state.view === 'table' ? 'default' : 'ghost'}
							size="sm"
							onClick={() => setView('table')}
							className="rounded-r-none"
							aria-label="Table view"
							title="Table view"
						>
							<Table2 className="h-4 w-4" />
						</Button>
						<Button
							variant={state.view === 'cards' ? 'default' : 'ghost'}
							size="sm"
							onClick={() => setView('cards')}
							className="rounded-l-none"
							aria-label="Cards view"
							title="Cards view"
						>
							<LayoutGrid className="h-4 w-4" />
						</Button>
					</div>
					<Button onClick={handleAdd} size="sm" className="cursor-pointer">
						<Plus className="h-4 w-4 mr-2" />
						Add Domain
					</Button>
				</div>
			</div>
			<div className="flex-1 overflow-auto">
				{state.view === 'table' ? (
					<DomainsTable
						domains={domains}
						onSelect={handleSelect}
						onAdd={handleAdd}
						selectedId={state.recordId || undefined}
					/>
				) : (
					<DomainsCards
						domains={domains}
						onSelect={handleSelect}
						onAdd={handleAdd}
						selectedId={state.recordId || undefined}
					/>
				)}
			</div>
		</div>
	)

	return (
		<div className="flex flex-col h-full">
			{listPanel}
			<Drawer open={state.isOpen} onOpenChange={(open) => !open && closePanel()} direction="right">
				<DrawerContentRight>
					<DomainRecordPanel
						onClose={() => closePanel()}
						domain={selectedDomain}
						isNew={state.mode === 'new'}
					/>
				</DrawerContentRight>
			</Drawer>
		</div>
	)
}
